import {configure} from '@wr/plutonium/store';
import React from 'react';
import ReactDom from 'react-dom';
import {Provider} from 'react-redux';
import reducers from '../../../common/reducers';
import Router from './Router';
import sendWebVitalReport from '../../../common/utils/sendWebVitalReport';
import {reportWebVitals} from '../modules/reportWebVitals';

const initial = window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle
delete window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle

const serverSideProps = window.__SERVER_SIDE_PROPS__; // eslint-disable-line no-underscore-dangle
delete window.__SERVER_SIDE_PROPS__; // eslint-disable-line no-underscore-dangle

export default () => {
    const configuredStore = configure(initial, reducers);

    ReactDom.render(
        <Provider store={configuredStore}>
            <Router serverSideProps={serverSideProps} />
        </Provider>,
        document.getElementById('app')
    );
};

const wrappedSendWebVitalReportWithState = metric => sendWebVitalReport(metric, initial);
reportWebVitals(wrappedSendWebVitalReportWithState);
